/**
 * Menu script
 */
class Kosmopedia_Menu {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.site-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menuBlock = this.menuWrapper.find('.menu-block');
        this.menuItemSubmenu = this.menuWrapper.find('.menu-item-has-children');
        this.submenu = this.menuItemSubmenu.find('.sub-menu');
        this.submenu.prepend( "<li class='menu-item'><a href='#' class='btn back'></a></li>" );
        this.menuBackBtn = $('a.btn.back');
        this.mobileViewport = window.matchMedia("screen and (max-width: 1024px)");
    }

    initEvents() {
        this.menuItemSubmenu.append( "<span class='arrow'></span>" );

        $(window).on('scroll', () => {
            let positionY = this.win.scrollTop();

            if (positionY > 80 && !this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.addClass('is-fixed');
                return;
            }

            if (positionY <= 80 && this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.removeClass('is-fixed');
            }
        });

        if (this.menuIcon.length) {
            this.menuIcon.on('click', e => {
                e.preventDefault();
                this.menuWrapper.toggleClass('is-open');
                this.menuBlock.toggleClass('is-active');
                this.menuIcon.toggleClass('is-active');
                $(document.body).toggleClass('no-scroll');

                setTimeout(() => {
                    this.menuBlock.toggleClass('is-showing');
                }, 150);
            });
        }

        if (this.mobileViewport.matches) {
            this.initUI();
        }

        this.mobileViewport.addListener((mq) => {
            if (mq.matches) {
                this.initUI();
            } else {
                this.menuWrapper.removeClass('is-open');
                this.menuBlock.removeClass('is-showing');
                this.menuIcon.removeClass('is-active');
                $(document.body).removeClass('no-scroll');
                this.submenu.removeClass('is-active');

                setTimeout(() => {
                    this.menuBlock.removeClass('is-active');
                }, 150);
            }
        });
    }

    initUI () {
        setTimeout(() => {
            this.menuSubmenuToggle = this.menuItemSubmenu.find('.arrow');
            
            this.menuSubmenuToggle.each(function(i, item) {
                $(item).on('click', (e) => {
                    e.stopPropagation();
                    $(item).parent().children('.sub-menu').first().addClass('is-active');
                    let submenuParentText = $(item).parent().find('a').first().text();
                    $(item).parent().find('a.btn.back').first().text(submenuParentText);
                });

                $(item).parent().find('a.btn.back').first().on('click', (e) => {
                    e.preventDefault();
                    $(item).parent().children('.sub-menu').removeClass('is-active');
                });
            });
        }, 0);
    }
}
